import { storageKey } from "app/utils/storageKeys";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const lastPage = atom<string | null>(null);

export const sortOrder = atomWithStorage<string>(storageKey.sortOrder, "lowest-price");

// Recently viewed products atom
export interface RecentlyViewedProductAtom {
  _id: string;
  name: string;
  image?: string;
  slug: string;
  description?: string;
  images?: string[];
  category?: string;
  subCategory?: string;
  [key: string]: any;
}

export const recentlyViewedProductsAtom = atomWithStorage<RecentlyViewedProductAtom[]>(
  storageKey.recentlyViewed,
  []
);


export const addViewedProductsAtom = atom(
  null,
  (get, set, newProduct: RecentlyViewedProductAtom) => {
    const currentProducts = get(recentlyViewedProductsAtom);

    // Remove the product if it already exists to avoid duplicates
    const filteredProducts = currentProducts.filter((product) => product._id !== newProduct._id);

    // If adding the new product would exceed 8 items, remove the last item
    if (filteredProducts.length >= 8) {
      filteredProducts.pop();
    }

    // Add the new product to the beginning of the array
    const updatedProducts = [newProduct, ...filteredProducts];

    set(recentlyViewedProductsAtom, updatedProducts);
  },
);